import React from "react";
import { useUser } from "../../../../context/AuthContext";
import Scope3ApprovalListCore from "../Scope3ApprovalListCore";
import SimpleScope3ApprovalDrawer from "../SimpleScope3ApprovalDrawer";

const mapLeasedRow = (item) => ({
  ...item,
  locationCountry:
    item?.locationCountry ??
    item?.country ??
    item?.asset?.locationCountry ??
    item?.assetId?.locationCountry ??
    "",
  assetID:
    item?.asset?.assetId ??
    item?.assetCode ??
    item?.lam?.assetId ??
    item?.assetId?.assetId ??
    item?.assetId?._id ??
    item?.assetID ??
    (typeof item?.assetId === "string" ? item.assetId : "") ??
    "",
  typeofAsset:
    item?.asset?.typeOfAsset ??
    item?.lam?.typeOfAsset ??
    item?.assetId?.typeOfAsset ??
    item?.typeofAsset ??
    item?.typeOfAsset ??
    "",
});

const DownstreamView = (props) => (
  <SimpleScope3ApprovalDrawer
    {...props}
    title="Downstream leased assets — change request"
  />
);

const DownstreamLeasedAssetsApproval = () => {
  const { user } = useUser();

  const headings = [
    { title: "Date", key: "createdAt" },
    user?.companyAdmin ? { title: "Facility", key: "facilityName" } : null,
    { title: "Consumption Month", key: "consumptionPeriod" },
    { title: "Asset ID", key: "assetID" },
    // { title: "Type of Asset", key: "typeofAsset" },
    { title: "Status", key: "requestStatus" },
    { title: "Created By", key: "createdBy" },
  ].filter(Boolean);

  return (
    <Scope3ApprovalListCore
      pageTitle="Downstream Leased Assets"
      apiSegment="downstreamLeasedAssets"
      ViewPage={DownstreamView}
      headings={headings}
      columnWidth={
        user?.companyAdmin
          ? "11% 12% 14% 14% 14% 14% 11%"
          : "12% 20% 20% 18% 18% 8%"
      }
      mapRow={mapLeasedRow}
    />
  );
};

export default DownstreamLeasedAssetsApproval;
